import { Area, Product, ProductCategory, RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { ProductNormalized } from '../products.model';
import { ProductActions } from './products.actions';

export const PRODUCTS_BY_CHANNEL_STATE_KEY = 'products';

export interface ProductsState {
    groupIds: any[];
    groups: any;
    allGroups: any[];
    productIds: any[];
    products: any;
    allProducts: any[];
    selectedGroupId: any;
    selectedProductId: any;
    matrixProductPrices: any;
    filteredProducts: any[]; // old way, will be deprecated
    byId: any;
    allIds: any[];
    filteredProductIds: any[];
}

export const PRODUCTS_INITIAL_STATE: ProductsState = {
    groupIds: [],
    groups: {},
    allGroups: [],
    productIds: [],
    products: {},
    allProducts: [],
    selectedGroupId: null,
    selectedProductId: null,
    matrixProductPrices: {},
    filteredProducts: [], // old way, will be deprecated
    byId: null,
    allIds: [],
    filteredProductIds: [],
};

export function productsReducer(
    lastState: ProductsState = PRODUCTS_INITIAL_STATE,
    action: RidangoReduxAction
): ProductsState {
    switch (action.type) {
        case ProductActions.PRICELIST_FETCH_START:
            return lastState;
        case ProductActions.PRICELIST_FETCH_SUCCESS:
            return tassign(lastState);
        case ProductActions.PRICELIST_FETCH_FAILED:
            return lastState;
        case ProductActions.PRICELIST_FETCH_END:
            return lastState;
        case ProductActions.SET_PRODUCT_GROUPS:
            return tassign(lastState, {
                groupIds: action.payload.groupIds,
                groups: action.payload.groups,
                allGroups: action.payload.allGroups,
            });
        case ProductActions.SET_PRODUCTS:
            return tassign(lastState, {
                productIds: action.payload.productIds,
                products: action.payload.products,
                allProducts: action.payload.allProducts,
            });
        case ProductActions.SET_SELECTED_GROUP_ID:
            return tassign(lastState, {
                selectedGroupId: action.payload,
            });
        case ProductActions.SET_SELECTED_PRODUCT_ID:
            return tassign(lastState, {
                selectedProductId: action.payload,
            });
        case ProductActions.SET_MATRIX_PRODUCT_PRICES:
            return tassign(lastState, {
                matrixProductPrices: action.payload,
            });
        case ProductActions.CLEAR_PRODUCTS:
            return tassign(lastState, PRODUCTS_INITIAL_STATE);
        case ProductActions.SET_FILTERED_PRODUCTS:
            return tassign(lastState, {
                filteredProducts: action.payload,
            });
    }

    return lastState;
}

/* Products by channel stuff (non mobile price list query) */
export interface ProductsByChannelState {
    all: Product[];
    normalized: ProductNormalized; // old way, should be deprecated when refactos are done for all regions
    byId: any;
    allIds: any[];
    filteredProductIds: any[];
    selected: Product;
    selectedProductId: number;
    matrixProductPrices: any;
    fixedSumProductIds: number[];
    variableSumProductId: number;
    filteredProducts: Product[];
    filters: {
        area: Area;
        traveller: ProductCategory;
        product: ProductCategory;
    };
    loading: boolean;
}

export const PRODUCTS_BY_CHANNEL_INITIAL_STATE: ProductsByChannelState = {
    all: [],
    normalized: {}, // old way, should be deprecated when refactos are done for all regions
    byId: null,
    allIds: [],
    filteredProductIds: [],
    selected: null,
    selectedProductId: null,
    matrixProductPrices: {},
    fixedSumProductIds: [],
    variableSumProductId: null,
    filteredProducts: [],
    filters: {
        area: null,
        traveller: null,
        product: null,
    },
    loading: false,
};

export function productsByChannelReducer(
    lastState: ProductsByChannelState = PRODUCTS_BY_CHANNEL_INITIAL_STATE,
    action: RidangoReduxAction
): ProductsByChannelState {
    switch (action.type) {
        case ProductActions.FETCH_PRODUCTS:
            return tassign(lastState, {
                loading: true,
            });
        case ProductActions.SET_PRODUCTS:
            return tassign(lastState, {
                all: action.payload.products,
                normalized: action.payload.normalized,
                byId: action.payload.byId,
                allIds: action.payload.allIds,
                fixedSumProductIds: action.payload.fixedSumProductIds,
                variableSumProductId: action.payload.variableSumProductId,
                loading: false,
            });
        case ProductActions.FETCH_PRODUCTS_FAIL:
            return tassign(lastState, {
                loading: false,
            });
        case ProductActions.SET_SELECTED_PRODUCT_ID:
            return tassign(lastState, {
                selectedProductId: action.payload,
            });
        case ProductActions.SET_SELECTED_PRODUCT:
            return tassign(lastState, {
                selected: action.payload,
            });
        case ProductActions.SET_MATRIX_PRODUCT_PRICES:
            return tassign(lastState, {
                matrixProductPrices: action.payload,
            });
        case ProductActions.SET_FILTERED_PRODUCTS:
            return tassign(lastState, {
                filteredProducts: action.payload, // this should be removed in future
                filteredProductIds: action.payload.map(p => p.product_id)
            });
        case ProductActions.SET_AREA_FILTER:
            return tassign(lastState, {
                filters: { ...lastState.filters, area: action.payload },
            });
        case ProductActions.SET_PRODUCT_CATEGORY_FILTER:
            return tassign(lastState, {
                filters: { ...lastState.filters, product: action.payload },
            });
        case ProductActions.SET_TRAVELLER_CATEGORY_FILTER:
            return tassign(lastState, {
                filters: { ...lastState.filters, traveller: action.payload },
            });
        case ProductActions.APPLY_FILTERS:
            return tassign(lastState, {
                selected: null, // lets try, seems ok, to deselect product when new fliters are applied
                filteredProducts: lastState.all
                    .filter((p) => p.area === (lastState.filters.area ? lastState.filters.area.area_id : p.area))
                    .filter(
                        (p) =>
                            p.product_category_ids &&
                            ((lastState.filters.traveller &&
                                p.product_category_ids.indexOf(lastState.filters.traveller.id) > -1) ||
                                !lastState.filters.traveller)
                    )
                    .filter(
                        (p) =>
                            p.product_category_ids &&
                            ((lastState.filters.product &&
                                p.product_category_ids.indexOf(lastState.filters.product.id) > -1) ||
                                !lastState.filters.product)
                    ),
            });
    }

    return lastState;
}

export interface ProductsPartialStoreState {
    [PRODUCTS_BY_CHANNEL_STATE_KEY]: ProductsByChannelState;
}
